// A'gong Hero — scroll-driven overlay/content fade (lightweight replacement for GSAP ScrollTrigger pin)
document.addEventListener('DOMContentLoaded', function () {
  var heroes = document.querySelectorAll('[data-agong-hero]');
  if (!heroes.length) return;

  heroes.forEach(function (hero) {
    var overlay = hero.querySelector('[data-agong-hero-overlay]');
    var content = hero.querySelector('[data-agong-hero-content]');
    var scrollInd = hero.querySelector('[data-agong-hero-scroll-ind]');
    var fixedBg = hero.querySelector('[data-agong-hero-fixed-bg]');
    var maxOpacity = parseFloat(getComputedStyle(hero).getPropertyValue('--agong-hero-overlay-opacity')) || 0.97;

    // Find the section that the fixed video should stay behind (Hero + the section right after it,
    // e.g. Durian Showcase). Falls back to just the Hero's own height if no sibling section found.
    var bgBoundsEl = document.getElementById('agong-showcase');
    if (!bgBoundsEl) {
      var next = hero.nextElementSibling;
      bgBoundsEl = (next && next.classList && next.classList.contains('agong-section')) ? next : hero;
    }

    function update() {
      var rect = hero.getBoundingClientRect();
      var height = rect.height || window.innerHeight;
      // progress: 0 at top of viewport, 1 after scrolling ~60% of hero height past top
      var scrolled = Math.min(Math.max(-rect.top, 0), height * 0.4);
      var progress = scrolled / (height * 0.4);

      if (overlay) {
        var overlayProgress = Math.min(Math.max((progress - 0.3) / 0.4, 0), 1);
        var baseOpacity = 0.08;
        overlay.style.opacity = (baseOpacity + overlayProgress * (maxOpacity - baseOpacity)).toString();
      }

      if (content) {
        var contentProgress = Math.min(Math.max((progress - 0.5) / 0.4, 0), 1);
        content.style.opacity = (1 - contentProgress).toString();
        content.style.transform = 'translateY(' + (-40 * contentProgress) + 'px)';
      }

      if (scrollInd) {
        var indProgress = Math.min(progress / 0.15, 1);
        scrollInd.style.opacity = (1 - indProgress).toString();
      }

      // Hide the fixed video once the bottom of the bounding section has scrolled
      // past the top of the viewport — prevents it bleeding through later sections.
      if (fixedBg && bgBoundsEl) {
        var boundsRect = bgBoundsEl.getBoundingClientRect();
        fixedBg.style.display = boundsRect.bottom <= 0 ? 'none' : '';
      }
    }

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  });
});
